export type IFormLinkSearchChangePage = (
  fieldFormLinkId: string,
  formLocalCode: string,
  parentDataBundleUUID: string,
  fieldSuffix: string,
  search: string,
  pageIndex: number,
  pageSize: number
) => void;

export function formLinkSearchChangePage(
  fieldFormLinkId: string,
  formLocalCode: string,
  parentDataBundleUUID: string,
  fieldSuffix: string,
  search: string,
  pageIndex: number,
  pageSize: number
): void {
  const url = `${
    window.actionBaseUrl
  }form_link_search?fieldFormLinkId=${fieldFormLinkId}&formLocalCode=${formLocalCode}&puuid=${parentDataBundleUUID}&pageIndex=${pageIndex}&pageSize=${pageSize}&term=${encodeURIComponent(
    search
  )}&fieldSuffix=${fieldSuffix}`;
  const $modal = $(`#formlink-search-modal-${fieldFormLinkId}`);
  const $content = $modal.find('.data-container');

  $.get(url, (responseData) => {
    $content.html(responseData);
    window.DexeroCoreApp._hookupSearchInFormLinkSearchPopup(
      $content.find(`#searchValue${fieldFormLinkId}`) as JQuery<HTMLInputElement>
    );
  });
}
